import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { SingleCabinLuggagePolicySection1 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection1";
import { SingleCabinLuggagePolicySection2 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection2";
import { LagsSection1 } from "../LagsSection/LagsSection1";
import { LagsSection2 } from "../LagsSection/LagsSection2";
import { LagsSection3 } from "../LagsSection/LagsSection3";
import { LagsSection4 } from "../LagsSection/LagsSection4";

export const Lags = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Page Content",
      key: "lagsPageContent",
      children: <LagsSection1 />
    },
    {
        label: "Liquid Item Image",
        key: "lagsLiquidItemImage",
        children: <LagsSection2 />
    },
    {
      label: "Disclaimer Content",
      key: "lagsDisclaimerContent",
      children: <LagsSection3 />
    },
    {
      label: "Guidelines Content",
      key: "lagsGuidelinesContent",
      children: <LagsSection4 />
    },
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("fourthChildActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${query.get('thirdChildActiveTab')}&fourthChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
